import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';

export const getDirtyFieldsValues = <T extends FieldValues>(
  dirtyFields: Partial<Record<keyof T, boolean>>,
  formMethods: UseFormReturn<T>
): Partial<T> => {
  return Object.keys(dirtyFields).reduce((acc, key) => {
    if (key in formMethods.getValues()) {
      acc[key as keyof T] = formMethods.getValues(key as Path<T>);
    }
    return acc;
  }, {} as Partial<T>);
};
